import { Component, OnInit, Input, Injector } from '@angular/core';
import { SelectBaseDirective } from '@shared/base/select-base/select-base';
import { SelectService } from '@shared/services/select.service';
import { SelectBaseTemplate } from '@shared/base/select-base/select-base.template';
import { SelectBaseStyle } from '@shared/base/select-base/select-base.style';
import { LanguageService } from '@shared/services';

@Component({
  selector: 'app-select-language',
  template: SelectBaseTemplate,
  styles: [SelectBaseStyle],
})
export class SelectLanguageComponent
  extends SelectBaseDirective
  implements OnInit
{
  @Input() isLanId = false;

  constructor(injector: Injector, private service: SelectService, private languageService: LanguageService) {
    super(injector, 'Language');
  }

  ngOnInit() {
    this.languageService
      .getLanguages(true, this.isLanId)
      .subscribe((data) => {
        this.data = [];
        for (const i of data) {
          this.data.push({ id: i.id, text: i.text });
        }
      });
  }
}
